import { gql } from '@apollo/client';

import { INVOICE_FRAGMENT, INVOICE_LINE_FRAGMENT } from './query';

// Invoice CRUD
export const INVOICE_CREATE = gql`
    ${INVOICE_FRAGMENT}
    mutation InvoiceCreate(
        $memberId: ID
        $companyId: ID
        $type: String
        $dueDate: Date!
        $headerNotes: String
        $footerNotes: String
        $internalNotes: String
        $lines: [InvoiceLineInput]
    ) {
        invoiceCreate(
            memberId: $memberId
            companyId: $companyId
            type: $type
            dueDate: $dueDate
            headerNotes: $headerNotes
            footerNotes: $footerNotes
            internalNotes: $internalNotes
            lines: $lines
        ) {
            invoice {
                ...InvoiceFragment
            }
        }
    }
`;

export const INVOICE_UPDATE = gql`
    ${INVOICE_FRAGMENT}
    mutation InvoiceUpdate(
        $id: ID!
        $dueDate: Date
        $headerNotes: String
        $footerNotes: String
        $internalNotes: String
        $discountAmount: Decimal
        $discountPercent: Decimal
        $discountDescription: String
    ) {
        invoiceUpdate(
            id: $id
            dueDate: $dueDate
            headerNotes: $headerNotes
            footerNotes: $footerNotes
            internalNotes: $internalNotes
            discountAmount: $discountAmount
            discountPercent: $discountPercent
            discountDescription: $discountDescription
        ) {
            invoice {
                ...InvoiceFragment
            }
        }
    }
`;

export const INVOICE_DELETE = gql`
    mutation InvoiceDelete($id: ID!) {
        invoiceDelete(id: $id) {
            success
            deletedId
        }
    }
`;

// Workflow mutations
export const INVOICE_SUBMIT_FOR_APPROVAL = gql`
    ${INVOICE_FRAGMENT}
    mutation InvoiceSubmitForApproval($id: ID!) {
        invoiceSubmitForApproval(id: $id) {
            invoice {
                ...InvoiceFragment
            }
        }
    }
`;

export const INVOICE_APPROVE = gql`
    ${INVOICE_FRAGMENT}
    mutation InvoiceApprove($id: ID!) {
        invoiceApprove(id: $id) {
            invoice {
                ...InvoiceFragment
            }
        }
    }
`;

export const INVOICE_REJECT = gql`
    ${INVOICE_FRAGMENT}
    mutation InvoiceReject($id: ID!, $reason: String) {
        invoiceReject(id: $id, reason: $reason) {
            invoice {
                ...InvoiceFragment
            }
        }
    }
`;

export const INVOICE_GENERATE_PREVIEW = gql`
    ${INVOICE_FRAGMENT}
    mutation InvoiceGeneratePreview($id: ID!) {
        invoiceGeneratePreview(id: $id) {
            invoice {
                ...InvoiceFragment
            }
            previewUrl
        }
    }
`;

export const INVOICE_SEND = gql`
    ${INVOICE_FRAGMENT}
    mutation InvoiceSend($id: ID!, $regeneratePdf: Boolean) {
        invoiceSend(id: $id, regeneratePdf: $regeneratePdf) {
            invoice {
                ...InvoiceFragment
            }
        }
    }
`;

export const INVOICE_MARK_PAID = gql`
    ${INVOICE_FRAGMENT}
    mutation InvoiceMarkPaid($id: ID!, $paymentDate: Date, $paymentNote: String) {
        invoiceMarkPaid(id: $id, paymentDate: $paymentDate, paymentNote: $paymentNote) {
            invoice {
                ...InvoiceFragment
            }
        }
    }
`;

export const INVOICE_CANCEL = gql`
    ${INVOICE_FRAGMENT}
    mutation InvoiceCancel($id: ID!, $reason: String!) {
        invoiceCancel(id: $id, reason: $reason) {
            invoice {
                ...InvoiceFragment
            }
        }
    }
`;

// Invoice Line mutations
export const INVOICE_LINE_CREATE = gql`
    ${INVOICE_FRAGMENT}
    ${INVOICE_LINE_FRAGMENT}
    mutation InvoiceLineCreate(
        $invoiceId: ID!
        $description: String!
        $quantity: Decimal
        $unitPrice: Decimal!
        $taxRate: Decimal
        $discountPercent: Decimal
        $discountAmount: Decimal
        $sortOrder: Int
    ) {
        invoiceLineCreate(
            invoiceId: $invoiceId
            description: $description
            quantity: $quantity
            unitPrice: $unitPrice
            taxRate: $taxRate
            discountPercent: $discountPercent
            discountAmount: $discountAmount
            sortOrder: $sortOrder
        ) {
            line {
                ...InvoiceLineFragment
            }
            invoice {
                ...InvoiceFragment
            }
        }
    }
`;

export const INVOICE_LINE_UPDATE = gql`
    ${INVOICE_FRAGMENT}
    ${INVOICE_LINE_FRAGMENT}
    mutation InvoiceLineUpdate(
        $id: ID!
        $description: String
        $quantity: Decimal
        $unitPrice: Decimal
        $taxRate: Decimal
        $discountPercent: Decimal
        $discountAmount: Decimal
        $sortOrder: Int
    ) {
        invoiceLineUpdate(
            id: $id
            description: $description
            quantity: $quantity
            unitPrice: $unitPrice
            taxRate: $taxRate
            discountPercent: $discountPercent
            discountAmount: $discountAmount
            sortOrder: $sortOrder
        ) {
            line {
                ...InvoiceLineFragment
            }
            invoice {
                ...InvoiceFragment
            }
        }
    }
`;

export const INVOICE_LINE_DELETE = gql`
    ${INVOICE_FRAGMENT}
    mutation InvoiceLineDelete($id: ID!) {
        invoiceLineDelete(id: $id) {
            success
            deletedId
            invoice {
                ...InvoiceFragment
            }
        }
    }
`;

export const INVOICE_LINE_REORDER = gql`
    ${INVOICE_FRAGMENT}
    mutation InvoiceLineReorder($invoiceId: ID!, $lineOrder: [ID]!) {
        invoiceLineReorder(invoiceId: $invoiceId, lineOrder: $lineOrder) {
            invoice {
                ...InvoiceFragment
            }
        }
    }
`;
